import { render } from "./Notification2.vue?vue&type=template&id=51a4de96"
import script from "./Notification2.vue?vue&type=script&lang=js"
export * from "./Notification2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__